export default "__VITE_ASSET__f00129cd__"